import React from 'react';
import AnimatedNumber from './component.animatedNumber';

// Counts up the first whole number found in an already-formatted string
// ("1 250 000 FCFA", "+475 000 FCFA"). Strings with decimals are shown as-is.
const NUM_RE = /\d[\d\s  ]*\d|\d/;

export default function AnimatedText({ text }) {
  const str = String(text ?? '');
  const m = str.match(NUM_RE);
  if (!m) return <>{str}</>;
  const end = m.index + m[0].length;
  if (/^[.,]\d/.test(str.slice(end))) return <>{str}</>;
  const value = Number(m[0].replace(/[\s  ]/g, ''));
  if (!Number.isFinite(value) || value > 1e15) return <>{str}</>;
  const grouped = /[\s  ]/.test(m[0]);
  const before = str.slice(0, m.index);
  return (
    <>
      {before}
      <AnimatedNumber value={value} format={n => (grouped ? n.toLocaleString('fr-FR') : String(n))} />
      {str.slice(end)}
    </>
  );
}
